import { ShopifyAjaxClient } from "@redotech/shopify-client/ajax";
import { createContext } from "react";

export const ShopifyAjaxClientContext = createContext<
  ShopifyAjaxClient | undefined
>(undefined);

export function shopifyProductHandle(url: string) {
  const u = new URL(url);
  return decodeURIComponent(u.pathname.split("/").pop()!);
}
